import { InspectorData, InspectorState } from 'modules/shares/Inspector/types'
import { Layer, SymbolMaster } from 'modules/shares/types'

/**
 * Finds the top-level symbol instance layer
 */
export const getSymbolLayer = (
  layers: InspectorData['layers'],
  selectedLayer: Layer
): Layer | null => {
  // Both layer list and selected layer are required
  if (!layers || !Object.keys(layers || {}).length || !selectedLayer) {
    return null
  }

  // Only selected layers with symbolMasterID can belong to symbols
  if (!selectedLayer.symbolMasterID) {
    return null
  }

  const parentLayer = layers[selectedLayer.parent as string]

  // It should never happen that a symbol instance layer has `symbolMasterID`
  // but not `isSymbolRoot`
  if (!parentLayer && !selectedLayer.isSymbolRoot) {
    // @TODO: this error will eventually come back after we figure out a way to fix the case of the symbol artboard Cloud#9689
    // ErrorHandler.shouldNeverHappen(
    //   'A symbol instance layer should have `isSymbolRoot`'
    // )
    return null
  }

  return selectedLayer.isSymbolRoot
    ? selectedLayer
    : getSymbolLayer(layers, parentLayer)
}

/**
 * Returns a boolean checking for a symbol layer
 */
export const isSymbolLayer = (layer?: Layer): boolean =>
  !!(layer?.symbolMasterID && layer?.isSymbolRoot)

/**
 * Gets the symbol data finding symbolMasterID in referencedSymbols Map
 */
export const getSymbolData = (
  inspectorData: InspectorState['data'],
  symbolMasterID: string
): SymbolMaster | null =>
  inspectorData?.referencedSymbols?.[symbolMasterID] || null
